import type { GoalDodItem } from './types';

export function goalDodDisplayText(dod?: string | null, goalDodItems?: GoalDodItem[] | null) {
  const legacyDod = dod?.trim();
  if (legacyDod) return legacyDod;
  if (!Array.isArray(goalDodItems)) return '';
  return goalDodItems
    .filter((item) => item && item.tracking !== 'retired')
    .map((item) => item.what?.trim())
    .filter((text): text is string => Boolean(text))
    .join(' / ');
}
